<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-lg">
      <!-- Brand Link -->
      <router-link :to="'/member/home'" class="navbar-brand">Sakha
      </router-link>

      <div class="d-flex align-items-start">
        <!-- Navbar Toggle Button -->
        <button class="btn btn-info collapsed d-block d-lg-none d-xl-none" style="margin-right: 10px;" type="button"
           >
          <span>
                    <i class="fa-icon fa-regular fa-wallet me-2"></i>฿{{ getBalance }}
                  </span>
        </button>
        <button class="navbar-toggler collapsed" type="button" @click="toggleNav" aria-controls="mainNav"
          :aria-expanded="isMainNavOpen" aria-label="Toggle navigation">
          <i class="fa-icon fa-regular fa-bars"></i>
        </button>

        <!-- Main Navigation Links -->
        <div class="collapse navbar-collapse" :class="{ show: isMainNavOpen }" id="mainNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" @click="gotolink('/member/home')">
                หน้าแรก
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" @click="gotolink('/article')">
                โปรโมชั่น
              </a>
            </li>
            <li class="nav-item">
              <a style="cursor: pointer;" class="nav-link"  @click="openLine()">ติดต่อเรา</a>
            </li>
          </ul>
        </div>

        <!-- User Navigation -->
        <div class="user-nav d-block">
          <!-- User Toggle Button -->
          <button class="navbar-toggler collapsed ms-2" type="button" @click="toggleUserNav" aria-controls="userNav"
            :aria-expanded="isUserNavOpen" aria-label="Toggle navigation">
            <i class="fa-icon fa-regular fa-user"></i>
          </button>

          <!-- User Dropdown -->
          <div class="collapse navbar-collapse ms-2" :class="{ show: isUserNavOpen }" id="userNav">
            <ul class="navbar-nav">
              <!-- Wallet Button -->
              <li class="nav-item">
                <a class="btn btn-info" href="#">
                  <span>
                    <i class="fa-icon fa-regular fa-wallet me-2"></i>฿{{ getBalance }}
                  </span>
                </a>
              </li>

              <!-- User Info Dropdown -->
              <li class="nav-item dropdown" ref="dropdownMenu">
                <a class="dropdown-toggle btn btn-primary" href="#" role="button" @click="toggleDropdown"
                  :aria-expanded="isDropdownOpen">
                  <span>
                    <i class="fa-icon fa-regular fa-circle-user me-2"></i>
                    <span class="me-2">{{ (getUsername.charAt(0) + getUsername.charAt(getUsername.length -
                      1)).toUpperCase() }}</span>
                  </span>
                  <span class="badge bg-dark">{{ getUsername }}</span>
                </a>
                <ul class="dropdown-menu dropdown-menu-end" :class="{ show: isDropdownOpen }">
                  <li v-for="(item, index) in dropdownItems" :key="index">
                    <a class="dropdown-item d-flex align-items-center" aria-current="page" @click="gotolink(item.link)">
                      <i  :class="item.icon + ' me-2'"></i>{{ item.label }}
                    </a>
                  </li>
                  <li v-if="dropdownItems.length > 0" class="d-none d-lg-block">
                    <hr class="dropdown-divider">
                  </li>
                  <li>
                    <a class="dropdown-item d-flex align-items-center" @click="onLogout">
                      <i class="fa-icon fa-regular fa-arrow-left-from-bracket me-2"></i>ออกจากระบบ
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import CallCenterModal from '@/components/modals/CallCenterModal'
import { checkCreditTurn } from '@/services'
import { STATUS_SUCCESS } from '@/constants'
export default {
  data () {
    return {
      language: localStorage.getItem('locale') ?? 'th',
      AGENT_EXT_NAME: process.env.VUE_APP_EXT_NAME,
      isMainNavOpen: false,
      isUserNavOpen: false,
      isDropdownOpen: false,
      activePage: 'home',
      walletAmount: '999,999',
      phoneNumber: '0993569566',
      userBadge: '9566#11',
      dropdownItems: [
        { link: '/member/lottoRecordList', label: 'โพยหวย', icon: 'fa-icon fa-regular fa-clipboard-list', action: 'list' },
        { link: '/member/deposit', label: 'เติมเงิน', icon: 'fa-icon fa-regular fa-up-to-line', action: 'topup' },
        { link: '/member/affiliate', label: 'แนะนำเพื่อน', icon: 'fa-icon fa-regular fa-user-group', action: 'refer' },
        { link: '/setting/profile', label: 'เปลี่ยนรหัสผ่าน', icon: 'fa-icon fa-regular fa-key', action: 'changePassword' }
      ]
    }
  },
  async mounted () {
    console.log('this.isDropdownOpen' + this.isDropdownOpen)
    console.log('this.isMainNavOpen' + this.isMainNavOpen)
    console.log('this.isUserNavOpen' + this.isUserNavOpen)
    // document.addEventListener('click', this.handleClickOutside)
    console.log(this.$route.meta.isNoRequestFooter)
    await this.reqConfig({
      id: process.env.VUE_APP_AG_ID,
      afKey: this.afKey,
      agKey: this.agKey
    })
    if (this.isMember) {
      await this.getBalanceInfo()
      console.log('this.hasBank')
      console.log(this.hasBank)
      if (this.hasBank === null) {
        this.getMyAccountBanks()
      }
    }
    // await this.reqConfig(process.env.VUE_APP_AG_ID)
  },
  beforeUnmount () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    toggleNav () {
      this.isMainNavOpen = !this.isMainNavOpen
      console.log('this.isMainNavOpen==' + this.isMainNavOpen)
    },
    toggleUserNav () {
      this.isUserNavOpen = !this.isUserNavOpen
      console.log('this.isUserNavOpen==' + this.isUserNavOpen)
    },
    toggleDropdown () {
      document.addEventListener('click', this.handleClickOutside)
      // document.addEventListener('click', this.handleClickOutside)
      this.isDropdownOpen = !this.isDropdownOpen
      console.log('this.isDropdownOpen==' + this.isDropdownOpen)
    },
    setActivePage (page) {
      this.activePage = page
    },
    ...mapActions(['reqConfig', 'setIsActive', 'clearLogOut', 'setLoading', 'getMyAccountBanks', 'getBalanceInfo']),
    selectLangauge (lang) {
      this.language = lang
      this.$i18n.locale = lang?.toLowerCase()
      localStorage.setItem('locale', lang?.toLowerCase())
    },
    onLogout () {
      this.setIsActive(false)
      this.setLoading(true)
      this.clearLogOut()
      this.setLoading(false)
      console.log('onLogout 1')
      this.$router.replace('/sakha')
    },
    gotolink (link) {
      this.isDropdownOpen = false
      this.isMainNavOpen = false
      this.isUserNavOpen = false
      this.$router.replace(link)
    },
    openLine () {
      window.open(this.getLine)
    },
    isPageActive (pageName) {
      return (this.$route.name === pageName)
    },
    async gotoWithdraw () {
      const resp = await checkCreditTurn()
      if (resp.status_code === STATUS_SUCCESS) {
        if (resp.data.withdraw_able === false) {
          // this.setCreditTurn(resp.data.credit_turn)
          this.$router.replace('unavailablewithdraw')
        } else {
          this.$router.replace('withdraw')
        }
      }
    },
    isDisabled () {
      if (this.hasBank === null) {
        return 'disabled'
      }
      return ''
    },
    handleClickOutside (event) {
      // console.log('this.isDropdownOpen' +this.isDropdownOpen)
      // console.log('this.isMainNavOpen' + this.isMainNavOpen)
      // console.log('this.isUserNavOpen' + this.isUserNavOpen)
      if (this.$refs.dropdownMenu && !this.$refs.dropdownMenu.contains(event.target)) {
        this.isDropdownOpen = false
        console.log('this.isDropdownOpen' + this.isDropdownOpen)
        console.log('this.isMainNavOpen' + this.isMainNavOpen)
        console.log('this.isUserNavOpen' + this.isUserNavOpen)
        // this.isUserNavOpen = false
      }
    }
  },

  computed: {
    ...mapState({
      hasBank: state => state.bankModule.hasBank,
      isMember: (state) => state.authModule.isMember,
      afKey: (state) => state.registerModule.afKey,
      agKey: (state) => state.registerModule.agKey
    }),
    ...mapGetters(['getBalance', 'getUsername', 'getLine', 'getLogo1', 'getLine']),
    iconsFlags () {
      return this.language === 'th' ? 'flag-icon flag-icon-th' : 'flag-icon flag-icon-gb'
    },
    settingBank () {
      return this.hasBank ? '/member/settings/bank' : '/member/settings/bank/add'
    },
    deposit () {
      return this.hasBank ? '/member/deposit' : '/member/settings/bank/add'
    }
  }
}
</script>

<style scoped>
/* Optional custom styling */
</style>
